import request from '@/utils/request'

// 查询导入费用详情
export function queryImportFeeDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/importFee/queryImportFeeDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '查询导入费用详情失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
